export default __webpack_public_path__ + "media/color/vrsc-b33dbdd9.svg";